import React, { useMemo, useCallback, useState, useEffect } from "react";
import { Button, DataTable } from "@/components";
import { getEscalationData, getEscalationTypeLabel } from "../../../utils/Data";
import ColumnHelper from "@/utils/ColumnHelper";
import { useApi } from "@/";
import { Link, useNavigate } from "react-router-dom";
import { RightWrapper } from "../../../components";

const Careers = () => {
  const { callApi, error, loading } = useApi();
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await callApi("/admin/getCarriers", "GET", null);
        if (isMounted) {
          if (response.success && response.data) {
            console.log("Response", response.data);
            setCareers(response.data);
          } else if (response.error) {
            console.log("Error", response.error?.message || "Unknown error");
          }
        }
      } catch (error) {
        if (isMounted) {
          console.log("Error", error);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []); // Remove callApi from dependencies since it's stable

  console.log("Data:::", careers);
  // Format date values
  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);
  // Memoize filtered data to prevent unnecessary re-renders

  // Memoized table columns
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: " Name",
        accessorKey: "name",
        meta: {
          tooltip: (row) => row.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Email",
        accessorKey: "email",
        meta: {
          tooltip: (row) => row.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Message",
        accessorKey: "message",
        meta: {
          tooltip: (row) => row.message || "N/A",
        },
      }),
      ColumnHelper({
        header: "Phone",
        accessorKey: "phone",
        meta: {
          tooltip: (row) => row.phone || "N/A",
        },
      }),
      ColumnHelper({
        header: "Created Date",
        accessorKey: "createdAt",
        cell: (info) => formatDate(info.row.original.createdAt),
        meta: {
          tooltip: (row) => formatDate(row.createdAt),
        },
      }),
      ColumnHelper({
        header: "Experience",
        accessorKey: "experience",
        meta: {
          tooltip: (row) => row.experience || "N/A",
        },
      }),
    ],
    [],
  );
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <DataTable
          columns={columns}
          tittle="Carrers"
          data={careers}
          isLoading={loading}
          showCheckbox={false}
        />
      </div>
    </RightWrapper>
  );
};

export default Careers;
